// SamostoyatelnayaRegistratsiyaTantsoraFederatsii
import React, { useState, useEffect } from 'react';
import { Form, Select } from 'antd';




const { Option } = Select;


export default function SamostoyatelnayaRegistratsiyaTantsoraFederatsii(props) {
    const { auth } = props;
    const [regionalnieOtdeleniya, setRegionalnieOtdeleniya] = useState([]);

    useEffect(() => {
        auth.fetch('/api/query/RegionalnieOtdeleniya?s-nazvanie').then(res => {
            if (res && res.data) {
                setRegionalnieOtdeleniya(res.data);
            }
        });
    }, []);

    const options = regionalnieOtdeleniya.map(i => (
        <Option key={i.ID} value={i.ID}>{i.nazvanie}</Option>
    ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                // neobkhodimiiKvorum: 50,
            }}
        >
            <Form.Item
                name={"regionalnoeOtdelenieID"}
                label={"Региональное отделение"}
                rules={[{ required: true, message: 'Укажите региональное отделение!' }]}
            >
                <Select showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>
        </Form>
    );
}
